<script>
import ImageSvg from 'logged/utils/underline-ultramarineblue.svg';
export default {
    components: {
        ImageSvg,
    },
    template: '<ImageSvg></ImageSvg>',
};
</script>
